import React, { Component } from "react";
import { IndexLink, Link } from "react-router";
import Logo from "../../../components/Logo/NexoidDevLogo";
import Search from "../../../components/Search/Search";
import NexoidLink from "../../../components/Page/NexoidLink";
import BasePage from "../../../components/Page/BasePage";
import SiteMap from "../../../components/Menu/SiteMap";
import { Scrollbars } from "react-custom-scrollbars";

import $ from "jquery";

class Home extends BasePage {
  constructor(props) {
    super(props);

    this.state = {};

    this.setMeta(
      "Nexoid Developer",
      "Make amazing, powerful, customised business systems using the Nexoid platform. Nexoid Developer is a detail rich resource full of examples that tells you everything you need to know. Learn how to import / export data, design interfaces, create complex workflows and Integrate with third-party systems. At Nexoid we strive for perfection and encourage you to tell us how we are doing. Each article has a feed back link. If the article has a mistake or you think the information wasn’t clear enough please do let us know and we will fix it as quickly as possible."
    );
  }

  componentDidMount() {
    $("html").scrollTop(0);
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Scrollbars
          style={{ height: "100%" }}
          onScrollFrame={this.handleScroll.bind(this)}
          ref={s => {
            this.mountScrollbar(s);
          }}
          renderThumbVertical={props => (
            <div {...props} className="thumb-vertical" />
          )}
        >
          <div
            className="showBig"
            style={{
              backgroundColor: "#0f111a",
              paddingBottom: 70,
              paddingTop: 70
            }}
          >
            <div
              style={{
                position: "absolute",
                display: "block",
                right: 16,
                top: 16
              }}
              className="noselect"
            >
              <Search />
            </div>
            <div
              style={{
                position: "absolute",
                display: "block",
                left: 16,
                top: 16
              }}
              className="noselect"
            >
              <NexoidLink />
            </div>
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                width: 500,
                height: 155
              }}
            >
              <Logo />
            </div>
          </div>
          <div className="showSmall" style={{ backgroundColor: "#0f111a" }}>
            <div style={{ display: "block", height: 64 }}>
              <div
                style={{
                  position: "absolute",
                  display: "block",
                  right: 16,
                  top: 16
                }}
              >
                <Search />
              </div>
              <div
                style={{
                  position: "absolute",
                  display: "block",
                  left: 16,
                  top: 16
                }}
              >
                <NexoidLink />
              </div>
            </div>
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                width: 250,
                height: 77,
                padding: 10
              }}
            >
              <Logo />
            </div>
          </div>
          <div>
            <div
              style={{
                textAlign: "center",
                padding: 10,
                maxWidth: 920,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <div
                style={{
                  textAlign: "justify",
                  fontWeight: "normal",
                  paddingTop: 20,
                  paddingBottom: 20
                }}
              >
                <p>
                  Make amazing, powerful, customised business systems using the
                  Nexoid platform. Nexoid Developer is a detail-rich resource
                  full of examples that tells you everything you need to know.
                  Learn how to import / export data, design interfaces, create
                  complex workflows and Integrate with third-party systems. At
                  Nexoid, we strive for perfection and encourage you to tell us
                  how we are doing. Each article has a feed backlink. If the
                  article has a mistake or you think the information wasn’t
                  clear enough please do let us know and we will fix it as
                  quickly as possible.
                </p>
              </div>

              <div className="homeIcon noselect">
                <Link to="/Overview">
                  <div className="homeIconMiddle">
                    <img src="img/home/Rocket.png" />
                    <h1>Overview</h1>
                    <h4>
                      Get a better understanding of how the Nexoid ecosystem
                    </h4>
                  </div>
                </Link>
              </div>
              <div className="homeIcon noselect">
                <Link to="/API">
                  <div className="homeIconMiddle">
                    <img src="img/home/API.png" />
                    <h1>API</h1>
                    <h4>Learn how to access and manipulate your data</h4>
                  </div>
                </Link>
              </div>
              <div className="homeIcon noselect">
                <Link to="/Interface">
                  <div className="homeIconMiddle">
                    <img src="img/home/Computer.png" />
                    <h1>Interface</h1>
                    <h4>
                      Build your own data interfaces and modify pre-built
                      business modules
                    </h4>
                  </div>
                </Link>
              </div>
              <div className="homeIcon noselect">
                <Link to="/Workflow">
                  <div className="homeIconMiddle">
                    <img src="img/home/Robot.png" />
                    <h1>Workflow</h1>
                    <h4>Create simple yet powerful workflow automation</h4>
                  </div>
                </Link>
              </div>
              <div className="homeIcon noselect">
                <Link to="/Security">
                  <div className="homeIconMiddle">
                    <img src="img/home/Security.png" />
                    <h1>Security</h1>
                    <h4>
                      Understand the Nexoid object and record level permission
                      structure
                    </h4>
                  </div>
                </Link>
              </div>
              <div className="homeIcon noselect">
                <Link to="/Integration">
                  <div className="homeIconMiddle">
                    <img src="img/home/Intergration.png" />
                    <h1>Integration</h1>
                    <h4>
                      Integrate with active directory, exchange server and other
                      third-party systems
                    </h4>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: "#0f111a" }}>
            <div
              style={{
                textAlign: "center",
                padding: 10,
                maxWidth: 920,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <div
                className="siteMapDark"
                style={{
                  textAlign: "left",
                  fontWeight: "normal",
                  paddingTop: 20,
                  paddingBottom: 20,
                  color: "#ffffff"
                }}
              >
                <SiteMap />
              </div>
            </div>
          </div>
        </Scrollbars>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/routes/Home/components/Home.js